import React from 'react'
import '../App.css'
import VerticalMenu from '../components/VerticalMenu'
import BackButton from '../components/BackButton'
import HeaderDashboardByVehicle from '../components/HeaderDashboardByVehicle'
import HorizontalTicketMenuByVehicle from '../components/HorizontalTicketMenuByVehicle'
import TicketContentByVehicle from '../components/TicketContentByVehicle'
import CircularProgress from '@material-ui/core/CircularProgress'
import Time from '../components/Time'
import backIcon from '../images/backIcon.svg'
import config from '../config'
import {
  refreshToken
} from '../utils/token'
import {
  getUserInfo
} from '../utils/userInfo'

class CheckTicketByVehicleComponent extends React.Component {
  constructor () {
    super()
    this._isMounted = false
    this.state = {
      data: null
    }
  }

  componentDidMount () {
    const self = this
    this._isMounted = true
    var token = localStorage.getItem('token')
    if (this._isMounted) {
      getUserInfo(token)
        .then(response => response.json())
        .then(function (data) {
          if (data.error && data.error.code === 401) {
            refreshToken(localStorage.getItem('refresh_token'))
          }
          let d = new Date()
          d.setHours(0, 0, 0, 0)
          let myDate = d.toJSON()
          let vehicleNumber = self.props.location.state && self.props.location.state.vehicleNumber ? self.props.location.state.vehicleNumber : localStorage.getItem('vehicleNumber')
          fetch(
            `${config.couchdb_final_docs}ToCheckByVehicleAndDate?include_docs=true&startkey=["${vehicleNumber}", "${myDate}"]&endkey=["${vehicleNumber}", {}]`,
            { headers: { 'Access-Control-Allow-Origin': '*' } }
          )
            .then(response => response.json())
            .then((data) => {
              self.setState({
                data: data.rows
              })
            })
            .catch(error => { console.log(error) })
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    }
  }

  componentWillUnmount () {
    this._isMounted = false
  }

  backToList () {
    console.log("BACK TO LIST")
  }

  render () {
    return (
      <div className='App'>
        <table cellSpacing='0' cellPadding='0' style={styles.table}>
          <tbody>
            <tr>
              <td style={styles.colLeft}>
                <VerticalMenu />
              </td>
              <td style={styles.content}>
                <BackButton
                  link='all-report'
                  label='LISTE'
                  img={backIcon}
                  onClick={() => this.backToList()}
                />
                <HeaderDashboardByVehicle
                  vehicleNumber={this.props.location.state && this.props.location.state.vehicleNumber ? this.props.location.state.vehicleNumber : localStorage.getItem('vehicleNumber')}
                  enabled='ticket'
                />
                <HorizontalTicketMenuByVehicle
                  vehicleNumber={this.props.location.state && this.props.location.state.vehicleNumber ? this.props.location.state.vehicleNumber : localStorage.getItem('vehicleNumber')}
                  enabled='check'
                />
                { this.state.data 
                  ? <TicketContentByVehicle
                    route='CheckTicketByVehicle'
                    data={this.state.data}
                    vehicleNumber={this.props.location.state && this.props.location.state.vehicleNumber ? this.props.location.state.vehicleNumber : localStorage.getItem('vehicleNumber')}
                  />
                  : <CircularProgress style={{ color: '#7ED321', marginTop: '50px' }} color='inherit' />
                }
              </td>
              <td style={styles.colRight}>
                <Time />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }
}

const styles = {
  table: {
    width: '100%',
    height: '100vh',
    border: 'none'
  },
  colLeft: {
    backgroundColor: '#020202',
    width: '60px',
    verticalAlign: 'top',
    border: 'none'
  },
  content: {
    verticalAlign: 'top',
    backgroundColor: '#15191C',
    border: 'none'
  },
  colRight: {
    width: '42px',
    verticalAlign: 'top',
    backgroundColor: '#15191C',
    border: 'none'
  }
}

export default CheckTicketByVehicleComponent
